import { Configuration, CorpUserApi, SystemVersionApi, VersionFeatureUserGroupApi } from '@repo/codegen/teashop-base-api'
import { getConfig } from "@/api/utils"
import { service2 as service } from "@/utils/service"

const PREFIX = "/teashop_base"

/**
 * 惰性单例代理:首次属性访问才实例化。
 *
 * 不能在模块顶层 `new XxxApi(..., service)` — 本模块被 router/permission.ts 启动即加载,
 * 而 utils/service 的初始化 import 链(store 等)可能尚未完成,顶层取 service2 会命中 TDZ
 * 抛 "Cannot access 'service' before initialization"(2026-07-06 会员总览首屏白屏根因,
 * 此前即偶发 ERROR)。惰性化后首次调用发生在运行期,所有模块已初始化完毕。
 */
function lazySingleton<T extends object>(create: () => T): T {
  let instance: T | undefined
  return new Proxy({} as T, {
    get(_target, prop, receiver) {
      instance ??= create()
      const value = Reflect.get(instance, prop, receiver)
      return typeof value === "function" ? value.bind(instance) : value
    },
  })
}

function createBaseOptions() {
  return getConfig({ prefix: PREFIX })
}

export const baseAPI = lazySingleton(() => {
  const baseOptions = createBaseOptions()
  return new CorpUserApi(new Configuration({ baseOptions }), baseOptions.baseURL, service)
})

export const systemVersionAPI = lazySingleton(() => {
  const baseOptions = createBaseOptions()
  return new SystemVersionApi(new Configuration({ baseOptions }), baseOptions.baseURL, service)
})

export const versionFeatureUserGroupAPI = lazySingleton(() => {
  const baseOptions = createBaseOptions()
  return new VersionFeatureUserGroupApi(new Configuration({ baseOptions }), baseOptions.baseURL, service)
})
